
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ContainerFrame extends Vue {
  @Prop()
  width!: number;

  @Prop()
  height!: number;

  @Prop({
    default: false,
  })
  secandaIcon!: boolean;

  @Prop()
  title!: string;

  @Prop({
    default: false,
  })
  titleIsClickable!: boolean;

  get textColor(): string {
    if (this.secandaIcon) return "secandaRed--text";
    return "white--text";
  }
}
